import { render, staticRenderFns } from "./Part-Actions.vue?vue&type=template&id=35f7b4b4"
import script from "./Part-Actions.vue?vue&type=script&setup=true&lang=js"
export * from "./Part-Actions.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports